import {
  Box,
  Button,
  FormControlLabel,
  Modal,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { useSuperAdminSingleRol } from "../../../context/SuperAdmin/SingleRoleContext";
import { Controller, useForm } from "react-hook-form";
import { EditRoleFields } from "../../../interfaces/SuperAdmin/Pages/iDataRoles";
import { Estado } from "../../../interfaces/SuperAdmin/Others/iDataEstado";

const EditRoleModal = () => {
  const { isModalOpen, closeModal, role, editData, isEditing } =
    useSuperAdminSingleRol();
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<EditRoleFields>({
    defaultValues: {
      estado: role.estado,
      nombre: role.nombre,
      descripcion: role.descripcion,
    },
  });

  const onSubmit = (data: EditRoleFields) => {
    editData(data, role.id_rol);
  };

  const handleClose = () => {
    if (!isEditing) {
      reset();
      closeModal();
    }
  };

  return (
    <Modal
      open={isModalOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
        }}
      >
        <Typography
          id="edit-subscription-modal-title"
          variant="h6"
          component="h2"
        >
          Editar Rol
        </Typography>

        {/* Campo Nombre */}
        <Typography variant="body1" sx={{ mt: 3, fontWeight: 500 }}>
          Nombre
        </Typography>
        <Controller
          name="nombre"
          control={control}
          rules={{ required: "El nombre es obligatorio" }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              margin="normal"
              error={!!errors.nombre}
              helperText={errors.nombre?.message}
            />
          )}
        />

        {/* Campo Descripción */}
        <Typography variant="body1" sx={{ mt: 3, fontWeight: 500 }}>
          Descripción
        </Typography>
        <Controller
          name="descripcion"
          control={control}
          rules={{ required: "La descripción es obligatoria" }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              margin="normal"
              error={!!errors.descripcion}
              helperText={errors.descripcion?.message}
            />
          )}
        />

        {/* Switch de Estado */}
        <Typography variant="body1" sx={{ mt: 3, fontWeight: 500 }}>
          Estado
        </Typography>
        <Controller
          name="estado"
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Switch
                  {...field}
                  checked={field.value === Estado.ACTIVO}
                  onChange={(e) =>
                    field.onChange(
                      e.target.checked ? Estado.ACTIVO : Estado.INACTIVO
                    )
                  }
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#2E7D32",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#2E7D32",
                    },
                  }}
                />
              }
              label={field.value === Estado.ACTIVO ? "Activo" : "Inactivo"}
            />
          )}
        />

        <Box sx={{ mt: 3, textAlign: "right" }}>
          <Button
            variant="contained"
            sx={{ background: "#336B87" }}
            disabled={isEditing}
            type="submit"
          >
            {isEditing ? "Guardando" : "Guardar"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditRoleModal;
